import React, { useState } from 'react'
import { connect } from 'react-redux'
import { DateTime } from 'luxon'

import SimpleActionPopup from './SimpleActionPopup'
import FormInput from './FormInput'
import { errorToast, successToast } from '../helpers/ToastHelper'
import { updateConsultantStyleQuizOverride } from '../services/utils'

const StyleQuizOverridePopup = ({
  userId,
  userName,
  currentOverrideUntil,
  onChange,
  setShowPopup,
  token
}) => {
  const [loading, setLoading] = useState(false)
  const [date, setDate] = useState(
    currentOverrideUntil
      ? DateTime.fromISO(currentOverrideUntil).toFormat('yyyy-MM-dd')
      : ''
  )

  const isActive =
    currentOverrideUntil &&
    DateTime.fromISO(currentOverrideUntil) > DateTime.now()

  const handleSave = async () => {
    if (!date) {
      errorToast('Escolha uma data de validade.')
      return
    }

    setLoading(true)
    try {
      const until = DateTime.fromFormat(date, 'yyyy-MM-dd')
        .endOf('day')
        .toISO()
      await updateConsultantStyleQuizOverride(token, userId, until)
      successToast(
        `Jogo de Estilo liberado até ${DateTime.fromISO(until).toFormat(
          'dd/MM/yyyy'
        )}.`
      )
      onChange()
      setShowPopup(false)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  const handleRevoke = async () => {
    setLoading(true)
    try {
      await updateConsultantStyleQuizOverride(token, userId, null)
      successToast('Liberação manual do Jogo de Estilo removida.')
      onChange()
      setShowPopup(false)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  const popupContent = (
    <div className='max-w-[500px] m-auto'>
      <p className='small-paragraph mb-4'>
        {isActive ? (
          <>
            Liberação manual ativa até{' '}
            <b>
              {DateTime.fromISO(currentOverrideUntil).toFormat('dd/MM/yyyy')}
            </b>
            . Isso não muda o plano da consultora, só libera o Jogo de Estilo
            temporariamente para teste, independente do plano contratado.
          </>
        ) : (
          'Libera o Jogo de Estilo para essa consultora até a data escolhida, mesmo que o plano dela (ex.: Minimalista) não inclua a feature. Não altera o plano nem gera cobrança.'
        )}
      </p>
      <FormInput
        type='date'
        label='Liberar até'
        value={date}
        onChange={e => setDate(e.target.value)}
      />
    </div>
  )

  return (
    <SimpleActionPopup
      title={`Jogo de Estilo - ${userName}`}
      content={popupContent}
      onClosePopup={() => setShowPopup(false)}
      popupLoading={loading}
      firstActionButtonText={isActive ? 'REVOGAR LIBERAÇÃO' : undefined}
      onPressFirstActionButton={handleRevoke}
      secondActionButtonText='SALVAR'
      onPressSecondActionButton={handleSave}
    />
  )
}

const mapStateToProps = state => {
  const { user } = state
  return {
    token: user.token
  }
}

export default connect(mapStateToProps)(StyleQuizOverridePopup)
